// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__phEJu","form":"Auth_form__-qRlJ","title":"Auth_title__-YWpi","button__container":"Auth_button__container__vDQZL"};